ContinuousDeliveryMetricsApp.Views.BreakerSevenDays = Backbone.View.extend({
    className: "col-lg-12",

    initialize: function() {
        let self = this;

        $('.breaker-seven-days-ibox').append(this.$el);

        $.ajax({
          url: '/assets/js/admin/continuous-delivery-metrics/03_templates/breaker-seven-days.html',
          success: function(extTemplate) {
            self.template = _.template(extTemplate);
            self.render();
            self.model.fetch();
          },
          cache: false
        });

        this.model.on('change', this.render, this);
    },

    render: function() {
        var model = this.model.toJSON();
        this.$el.html(this.template(model));

        if (model.breakerSevenDays.length !== 1 || model.breakerSevenDays[0] != 'initial state') {
            $('.breaker-seven-days-ibox').toggleClass('sk-loading');
        }
    },

    close: function() {
        this.remove();
        this.unbind();
    }
});